import React, {useMemo, useState} from "react";
import {Input} from "antd";

const normalize = (text) => String(text === null || text === undefined ? '' : text).toLowerCase().replace(/ё/g, 'е');

// Every word of the query has to be found in one of the fields (a key or item => value).
// Phones match by digits, so "906 123" finds +7 (906) 123-45-67.
export const filterItems = (items, query, fields) => {
  const words = normalize(query).split(/\s+/).filter(Boolean);
  if (!words.length) return items;
  return items.filter((item) => {
    const values = fields
      .map((field) => (typeof field === 'function' ? field(item) : item[field]))
      .flat()
      .filter((value) => value !== null && value !== undefined);
    const text = normalize(values.join(' '));
    const digits = values.join(' ').replace(/\D/g, '');
    return words.every((word) => {
      const wordDigits = word.replace(/\D/g, '');
      return text.includes(word) || (wordDigits.length >= 3 && wordDigits.length === word.replace(/[\s+()-]/g, '').length && digits.includes(wordDigits));
    });
  });
};

// [query, setQuery, items that match]
export const useSectionSearch = (items, fields) => {
  const [query, setQuery] = useState('');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const found = useMemo(() => filterItems(items || [], query, fields), [items, query]);
  return [query, setQuery, found];
};

// "Всего 12" or, while searching, "Найдено 3 из 12"
export const countText = (total, shown, search) => (search && search.trim() ? `Найдено ${shown} из ${total}` : `Всего ${total}`);

// Search field, the section's filters and count on the left, its buttons on the right
export const SectionToolbar = ({search, onSearch, placeholder, filters, count, children}) => (
  <div className='section-toolbar'>
    {onSearch && (
      <Input.Search
        allowClear
        className='section-toolbar__search'
        placeholder={placeholder}
        value={search}
        onChange={(e) => onSearch(e.target.value)}
      />
    )}
    {filters}
    {count && <span className='section-toolbar__count'>{count}</span>}
    <div className='section-toolbar__spacer'/>
    {children}
  </div>
);
